module.exports = {"310112001":"江川路街道","310112006":"古美街道","310112008":"新虹街道","310112009":"浦锦街道","310112101":"莘庄镇","310112102":"七宝镇","310112103":"颛桥镇","310112106":"华漕镇","310112107":"虹桥镇","310112108":"梅陇镇","310112110":"吴泾镇","310112112":"马桥镇","310112114":"浦江镇","310112501":"莘庄工业区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/310112.json
// module id = 915
// module chunks = 0